import React from 'react';
import { FormContainer } from '../../common/form/FormContainer';
import FormItem from '../../common/form/FormItem';
import FormWidget from '../../common/form/FormWidget';
import { Field } from '../attributes';

type DateAttributeEditorProps = {
    field: Field;
};

export default (props: DateAttributeEditorProps) => {
    const { field } = props;
    return (
            <FormContainer>
                <FormItem>
                    <FormWidget name={field.name} label={field.label} component="Date" />
                </FormItem>
            </FormContainer>
    );
};
